import React, { useState, useEffect } from 'react'
import fetchHook from '../../../hooks/fetchMSSQL-hook'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import NoResults from '../../../components/NoResults/NoResults'
import SearchFilter from '../../../components/Filter/SearchFilter'
import moment from 'moment'
import 'moment/locale/pl'

export default function PrepaidGroup() {
  const { fetchMssqlApi } = fetchHook()

  const [prepaidGroups, setPrepaidGroups] = useState([])
  const [windowHeight, setWindowHeight] = useState(window.innerHeight)

  const defaultFilter = {
    name: 'prepaidGroups',
    page: 1,
    rowsPerPage: 50,
    sortBy: 'none',
    prepaidId: null,
    prepaidTimespanName: '',
    prepaidTimespanId: null,
    prepaidGroupName: '',
    prepaidGroupId: null,
    isActive: 'true',
    enabled: 'null',
    overwriteCredit: 'null',
    customerAbbr: null,
  }

  const [filter, setFilter] = useState(defaultFilter)
  const [settingsFilter, setSettingsFilter] = useState({
    saveFilters: true,
    autoLoading: true,
    additionalFilter: true,
    flatView: false,
    rowsPerPage: 50,
  })

  const rowsPerPage =
    settingsFilter.rowsPerPage || filter.rowsPerPage || 50

  const search = (f) => {
    const currentFilter = f || filter

    const body = {
      PrepaidId: currentFilter.prepaidId ?? null,
      PrepaidGroupId: currentFilter.prepaidGroupId || null,
      TimespanId: currentFilter.prepaidTimespanId || null,
      IsActive:
        currentFilter.isActive === 'true'
          ? true
          : currentFilter.isActive === 'false'
          ? false
          : null,
      Enabled:
        currentFilter.enabled === 'true'
          ? true
          : currentFilter.enabled === 'false'
          ? false
          : null,
      OverwriteCredit:
        currentFilter.overwriteCredit === 'true'
          ? true
          : currentFilter.overwriteCredit === 'false'
          ? false
          : null,
      CustomerAbbr: currentFilter.customerAbbr || null,
    }


    console.log("FILTER:", currentFilter);
console.log("BODY:", body);

    fetchMssqlApi(
      'prepaid-groups-by-params',
      { method: 'POST', data: body, hideNotification: true },
      (res) => setPrepaidGroups(res || [])
    )
  }

  useEffect(() => {
    search()
  }, [])

  return (
    <>
      <SearchFilter
        filterName="prepaidGroups"
        defaultFilter={defaultFilter}
        onFilterChange={setFilter}
        onSettingsChange={(s) =>
          setSettingsFilter((prev) => ({ ...prev, ...s }))
        }
        search={search}
        totalCount={prepaidGroups.length}
        dataList={prepaidGroups}
        forNow
      />

      <div className="card">
        <h5 className="card-header">
          <div className="d-flex justify-content-between mt-1">
            Grupy prepaid
            <Link
              to={`/prepaids/group/0`}
              className="btn text-nowrap btn-outline-secondary"
            >
              <i className="fas fa-plus" />
            </Link>
          </div>
        </h5>

        <div className="overflow-auto" style={{ maxHeight: '70%' }}>
          {prepaidGroups.length ? (
            <div
                className="overflow-auto custom-scroll"
                style={{
                maxHeight: `${windowHeight - 268}px`,
                overflowY: 'auto',
                }}
            >
            <table className="table table-striped">
              <thead>
                <tr className="text-center pe-none headers-color">
                  <th className="align-middle">
                    Nazwa{' '}
                    {sessionStorage.getItem('clientId') === 'console' && (
                      <>
                        <br /> Klient
                      </>
                    )}
                  </th>
                  <th className="align-middle">
                    Następne uruchomienie
                    <br />
                    Częstotliwość zasilania
                  </th>
                  <th className="align-middle">
                    Ilość powiązanych terminali
                  </th>
                  <th className="align-middle">
                    Ilość powiązanych kart
                  </th>
                  <th className="align-middle">
                    Kredyt / Nadpisywanie <br />
                    Aktywna / Włączona
                  </th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                {prepaidGroups
                  .slice(
                    (filter.page - 1) * rowsPerPage,
                    filter.page * rowsPerPage
                  )
                  .map((prepaidGroup, idx) => (
                    <tr key={idx} className="text-center">
                      <td>
                        <div style={{ fontSize: '13px' }}>
                          {prepaidGroup.PrepaidGroupName}
                        </div>
                        {sessionStorage.getItem('clientId') ===
                          'console' && (
                          <div>{prepaidGroup.CustomerName}</div>
                        )}
                      </td>

                      <td className="text-center">
                        <div>{prepaidGroup.NextStart}</div>
                        <div>
                          <h5>
                            <span className="badge badge-primary align-middle text-white">
                              {prepaidGroup.PrepaidTimespanName}
                            </span>
                          </h5>
                        </div>
                      </td>

                      <td className="text-center">
                        <h3>
                          <span className="badge badge-primary align-middle">
                            {prepaidGroup.ConectedTerminals}
                          </span>
                        </h3>
                      </td>

                      <td className="text-center">
                        <h3>
                          <span className="badge badge-success align-middle">
                            {prepaidGroup.ConnectedPrepaids}
                          </span>
                        </h3>
                      </td>

                      <td className="text-center">
                        <div className="d-flex nowrap justify-content-center">
                          <h6>
                            <span className="badge badge-success align-middle">
                              {prepaidGroup.PrepaidStatus}
                            </span>
                          </h6>
                        </div>

                        <div className="d-flex nowrap justify-content-center align-items-center">
                          <h6>
                            <span className="badge badge-primary align-middle mr-2">
                              {Intl.NumberFormat('pl-PL', {
                                style: 'currency',
                                currency: 'PLN',
                              }).format(
                                (prepaidGroup.CreditValue || 0).toFixed(2)
                              )}
                            </span>
                          </h6>

                          {prepaidGroup.OverwriteCredit ? (
                            <h6>
                              <span className="badge badge-success align-middle">
                                Z nadpisywaniem
                              </span>
                            </h6>
                          ) : (
                            <h6>
                              <span className="badge badge-danger align-middle">
                                Bez nadpisywania
                              </span>
                            </h6>
                          )}
                        </div>

                        <div className="d-flex nowrap justify-content-center">
                          {prepaidGroup.IsActive ? (
                            <h6>
                              <span className="mr-2 badge badge-success align-middle">
                                Aktywna
                              </span>
                            </h6>
                          ) : (
                            <h6>
                              <span className="mr-2 badge badge-danger align-middle">
                                Nieaktywna
                              </span>
                            </h6>
                          )}

                          {prepaidGroup.Enabled ? (
                            <h6>
                              <span className="badge badge-success align-middle">
                                Włączona
                              </span>
                            </h6>
                          ) : (
                            <h6>
                              <span className="badge badge-warning align-middle">
                                Wyłączona
                              </span>
                            </h6>
                          )}
                        </div>
                      </td>

                      <td>
                        <div className="d-flex justify-content-end border-0">
                          <Link
                            className="mr-4 btn btn-outline-primary btn-sm"
                            to={`group/${prepaidGroup.PrepaidGroupId}`}
                          >
                            Edytuj
                          </Link>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            </div>
          ) : (
            <NoResults />
          )}
        </div>
      </div>
    </>
  )
}
